import TerminalLine from "./TerminalLine";

export default class TerminalMessage implements TerminalLine {
  readonly type = "message";
  readonly details: string | null = null;
  readonly expandedDetails: string | null = null;

  constructor(readonly message: string, readonly obj?: any) {
    if (obj) {
      this.details = JSON.stringify(obj);
      this.expandedDetails = JSON.stringify(obj, null, 2);
    }
  }
}
